import { render, staticRenderFns } from "./IncludePdfsInArchiveModeSelect.vue?vue&type=template&id=1ee7662b&scoped=true"
import script from "./IncludePdfsInArchiveModeSelect.vue?vue&type=script&lang=ts"
export * from "./IncludePdfsInArchiveModeSelect.vue?vue&type=script&lang=ts"
import style0 from "./IncludePdfsInArchiveModeSelect.vue?vue&type=style&index=0&id=1ee7662b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee7662b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee7662b')) {
      api.createRecord('1ee7662b', component.options)
    } else {
      api.reload('1ee7662b', component.options)
    }
    module.hot.accept("./IncludePdfsInArchiveModeSelect.vue?vue&type=template&id=1ee7662b&scoped=true", function () {
      api.rerender('1ee7662b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/IncludePdfsInArchiveModeSelect.vue"
export default component.exports